// iOS Safari colours the areas outside the page (rubber-band overscroll, and
// since Safari 26 the strips behind its status bar and bottom toolbar) from
// the root/body background *colour*; gradients and theme-color are ignored
// (the top bar also follows an opaque sticky header, see SiteHeader). The
// header is white and the footer black, so no single colour works: keep the
// canvas the page surface (pull-to-refresh, reading) and switch it to black
// once the footer reaches the bottom of the window, so the toolbar and
// overscroll past the footer aren't white. Both html and body are set (Safari
// 26 samples body); the page itself is painted by the layout wrapper in
// __root.tsx, so neither shows through. TOP is the dark surface in dark mode
// (the footer stays black in both themes).

const TOP = 'var(--color-surface)'
const BOTTOM = '#000'

/** Installs the scroll listener; returns a cleanup function. */
export function installOverscrollColor() {
  const root = document.documentElement
  const { body } = document
  let frame = 0
  let current = ''
  const update = () => {
    frame = 0
    const footer = document.querySelector('#main ~ footer')
    const atFooter =
      window.scrollY > 0 &&
      !!footer &&
      footer.getBoundingClientRect().top < window.innerHeight
    const color = atFooter ? BOTTOM : TOP
    if (color === current) return
    current = color
    root.style.backgroundColor = color
    body.style.backgroundColor = color
  }
  const onScroll = () => {
    frame ||= requestAnimationFrame(update)
  }
  update()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll, { passive: true })
  return () => {
    cancelAnimationFrame(frame)
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('resize', onScroll)
    root.style.backgroundColor = ''
    body.style.backgroundColor = ''
  }
}
